import { Phone, Mail, Check } from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import { LayoutDashboard, Trash2, Clock, Sparkles } from "lucide-react";


const STANDARD = [
  { emoji: "🗑️", label: "Bin / trash can cleaning", sub: "2 times per month" },
  { emoji: "🧴", label: "Disinfection of trash can area", sub: "2 times per month" },
  { emoji: "🌿", label: "Odor & bacteria reduction", sub: null },
];

const PREMIUM = [
  { emoji: "🗑️", label: "Bin / trash can cleaning", sub: "2 times per month" },
  { emoji: "🧴", label: "Disinfection of trash can area", sub: "2 times per month" },
  { emoji: "🛍️", label: "Trash bags provided", sub: "5 days per week" },
  { emoji: "🌸", label: "Deodorizer applied", sub: "to trash can area" },
  { emoji: "📱", label: "Service arrival notification", sub: "via text or email — 15 minutes before arrival" },
];

function FeatureItem({ emoji, label, sub, checkColor }) {
  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 12,
      padding: "10px 0",
      borderBottom: "1px solid rgba(0,0,0,.05)",
    }}>
      <div style={{
        width: 28, height: 28, borderRadius: "50%",
        background: checkColor + "18",
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, marginTop: 1,
        fontSize: 14,
      }}>
        {emoji}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)" }}>{label} </span>
        {sub && <span style={{ fontSize: 13, color: "var(--mut)", fontWeight: 400 }}>{sub}</span>}
      </div>
      <div style={{
        width: 22, height: 22, borderRadius: "50%",
        background: checkColor, flexShrink: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginTop: 2,
      }}>
        <Check size={12} color="#fff" strokeWidth={3} />
      </div>
    </div>
  );
}

function PlanCard({ tier, price, features, checkColor, headerBg, headerText, badge, delay }) {
  return (
    <div className={`fu ${delay}`} style={{
      background: "#fff",
      borderRadius: 18,
      border: `2px solid ${checkColor}30`,
      overflow: "hidden",
      boxShadow: "0 4px 24px rgba(0,0,0,.07)",
      display: "flex", flexDirection: "column",
    }}>
      {/* Header */}
      <div style={{
        background: headerBg,
        padding: "18px 24px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", color: headerText + "cc", marginBottom: 2 }}>
            {tier}
          </div>
          <div style={{ fontSize: 32, fontWeight: 800, color: headerText, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>
            ${price}
            <span style={{ fontSize: 14, fontWeight: 500, marginLeft: 4 }}>/mo</span>
          </div>
        </div>
        {badge && (
          <div style={{
            background: "rgba(255,255,255,.25)",
            border: "1px solid rgba(255,255,255,.4)",
            borderRadius: 20, padding: "4px 12px",
            fontSize: 11, fontWeight: 700, color: headerText,
            letterSpacing: ".5px",
          }}>
            {badge}
          </div>
        )}
      </div>

      {/* Features */}
      <div style={{ padding: "6px 24px 20px", flex: 1 }}>
        {features.map((f, i) => (
          <FeatureItem key={i} {...f} checkColor={checkColor} />
        ))}
      </div>
    </div>
  );
}



export default function OptionalServicesPage() {

const NAV = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/resident/dashboard" },
  { label: "My Trash",  icon: Trash2,  path: "/resident/my-trash" },
  { label: "History",   icon: Clock,   path: "/resident/history" },
  { label: "Services",  icon: Sparkles, path: "/resident/services", active: true },
];
  return (
    <DashboardLayout role="resident" title="Optional Services" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 28 }}>
        <div style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "2px",
          textTransform: "uppercase", color: "var(--g600)", marginBottom: 6,
        }}>
          Upgrade Your Service
        </div>
        <h2 style={{
          fontFamily: "'Playfair Display',serif",
          fontSize: 26, fontWeight: 500, color: "var(--ink)", marginBottom: 6,
        }}>
          Optional Services
        </h2>
        <p style={{ fontSize: 13.5, color: "var(--mut)", lineHeight: 1.6 }}>
          Upgrade your service for extra convenience &amp; cleanliness.
        </p>
      </div>

      {/* Plans grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: 20,
        marginBottom: 28,
      }}>
        <PlanCard
          tier="Standard"
          price={10}
          features={STANDARD}
          checkColor="#2e7d32"
          headerBg="linear-gradient(135deg,#2e7d32,#43a047)"
          headerText="#fff"
          delay="d1"
        />
        <PlanCard
          tier="Premium"
          price={20}
          features={PREMIUM}
          checkColor="#1565c0"
          headerBg="linear-gradient(135deg,#1565c0,#1976d2)"
          headerText="#fff"
          badge="⭐ Best Value"
          delay="d2"
        />
      </div>

      {/* Tagline */}
      <div className="fu d3" style={{
        background: "var(--g50)", border: "1px solid var(--g200)",
        borderRadius: 12, padding: "14px 20px",
        fontSize: 13.5, color: "var(--ink2)", fontStyle: "italic",
        textAlign: "center", marginBottom: 24,
        lineHeight: 1.6,
      }}>
        Perfect for residents who want a cleaner and healthier trash area.
      </div>

      {/* How to request */}
      <div className="fu d4" style={{
        background: "#fff", borderRadius: 16,
        border: "1px solid var(--ln)",
        padding: "24px",
        boxShadow: "0 1px 6px rgba(0,0,0,.04)",
      }}>
        <div style={{
          fontSize: 12, fontWeight: 800, letterSpacing: "2px",
          textTransform: "uppercase", color: "#1565c0",
          marginBottom: 10, textAlign: "center",
        }}>
          How to Request This Service
        </div>
        <p style={{ fontSize: 13.5, color: "var(--mut)", textAlign: "center", marginBottom: 20, lineHeight: 1.6 }}>
          To activate an optional service, contact Canluxa directly.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <a
            href="mailto:info@canluxa.com"
            style={{
              display: "flex", alignItems: "center", gap: 14,
              background: "var(--g50)", border: "1.5px solid var(--g200)",
              borderRadius: 12, padding: "14px 18px",
              textDecoration: "none", transition: "border-color .2s, background .2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--g400)"; e.currentTarget.style.background = "var(--g100)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--g200)"; e.currentTarget.style.background = "var(--g50)"; }}
          >
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              background: "var(--g600)",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}>
              <Mail size={18} color="#fff" strokeWidth={1.8} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".5px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 2 }}>Email</div>
              <div style={{ fontSize: 15, fontWeight: 600, color: "var(--g700)" }}>info@canluxa.com</div>
            </div>
          </a>

          <a
            href="tel:8133917775"
            style={{
              display: "flex", alignItems: "center", gap: 14,
              background: "#e3f2fd", border: "1.5px solid #90caf9",
              borderRadius: 12, padding: "14px 18px",
              textDecoration: "none", transition: "border-color .2s, background .2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "#1565c0"; e.currentTarget.style.background = "#bbdefb"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "#90caf9"; e.currentTarget.style.background = "#e3f2fd"; }}
          >
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              background: "#1565c0",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}>
              <Phone size={18} color="#fff" strokeWidth={1.8} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".5px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 2 }}>Phone</div>
              <div style={{ fontSize: 15, fontWeight: 600, color: "#1565c0" }}>813-391-7775</div>
            </div>
          </a>
        </div>

        {/* Footer note */}
        <div style={{
          marginTop: 20, paddingTop: 16,
          borderTop: "1px solid var(--ln)",
          fontSize: 12, color: "var(--mut)", textAlign: "center",
          fontStyle: "italic", lineHeight: 1.6,
        }}>
          Payments are handled directly with <strong style={{ color: "var(--ink)", fontStyle: "normal" }}>Canluxa</strong>.{" "}
          No in-app payments in Phase 1.
        </div>
      </div>

    </DashboardLayout>
  );
}